import Glightbox from "glightbox/src/js/glightbox";
const checkForImageUrl = (url) => {
    return(url.toString().match(/\.(jpeg|jpg|gif|png|svg|webp)$/) != null);
}
const handleLightboxSetup = () => {
    if(document.querySelector('.wp-block-stoof-stoof-gallery-block') || document.querySelector('.wp-block-gallery')){
        // init lightbox
        const lightbox = Glightbox(
            {
                touchNavigation: false,
                keyboardNavigation: false,
                draggable: false,
            }
        );

        document.addEventListener('click', ev => {
            if(!ev.target.closest('.swiper-slide, .wp-block-image')) return;
            ev.preventDefault();
            let link = ev.target.closest('a');

            if(link !== null ){
                let elements = []
                let chosenIndex = 0;
                let allImageLinks;
                let inGallery = false;
                if(link.closest('.swiper-wrapper')){
                    let swiper = link.closest('.swiper-wrapper');
                    allImageLinks = swiper.querySelectorAll('.swiper-slide > a');
                }

                if(link.closest('.wp-block-gallery')){
                    let gallery = link.closest('.wp-block-gallery');
                    allImageLinks = gallery.querySelectorAll('.wp-block-image > a');

                    inGallery = true;
                }

                if(allImageLinks && allImageLinks.length > 0){
                    let i = 0;
                    allImageLinks.forEach( l => {

                        let potentialLink = l.dataset.featherlight ?? l.href;

                        if(checkForImageUrl(potentialLink)){

                            if(l === link){
                                chosenIndex = i;
                            }
                            i++;
                            elements.push(
                                {
                                    'href': potentialLink,
                                    'type': 'image'
                                }
                            );
                        }

                    })
                }
                lightbox.setElements(elements);
                lightbox.settings.startAt = chosenIndex;

                if(inGallery){
                    lightbox.settings.touchNavigation = true;
                    lightbox.settings.keyboardNavigation = true;
                    lightbox.settings.draggable = true;
                }

                lightbox.open();

                if(!inGallery){
                    document
                        .querySelector('.glightbox-container')
                        ?.classList?.toggle('hide-navigation', !inGallery);
                }
            }


        })
    }
}
document.addEventListener('readystatechange', () => {
    if (document.readyState === 'complete') {
        handleLightboxSetup();
    }
})